
const Topbar = () => {
  return (
    <div className="topbar d-print-none">
      <div className="container-xxl">
        <nav className="topbar-custom d-flex justify-content-between" id="topbar-custom">

          <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
            <li>
              <button className="nav-link mobile-menu-btn nav-icon" id="togglemenu">
                <i className="iconoir-menu-scale"></i>
              </button>
            </li>
            <li className="mx-3 welcome-text">
              <h3 className="mb-0 fw-bold text-truncate">Wellcome To PoisaTrack</h3>
            </li>
          </ul>

          <ul className="topbar-item list-unstyled d-inline-flex align-items-center mb-0">
            <li className="hide-phone app-search">
              <form role="search" action="#" method="get">
                <input type="search" name="search" className="form-control top-search mb-0" placeholder="Search here..." />
                <button type="button"><i className="iconoir-search"></i></button>
              </form>
            </li>

            <li className="dropdown">
              <a className="nav-link dropdown-toggle arrow-none nav-icon" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                <img src="assets/images/flags/us_flag.jpg" alt="" className="thumb-sm rounded-circle" />
              </a>
              <div className="dropdown-menu">
                <a className="dropdown-item" href="#"><img src="assets/images/flags/us_flag.jpg" alt="" height="15" className="me-2" />English</a>
                <a className="dropdown-item" href="#"><img src="assets/images/flags/spain_flag.jpg" alt="" height="15" className="me-2" />Spanish</a>
                <a className="dropdown-item" href="#"><img src="assets/images/flags/germany_flag.jpg" alt="" height="15" className="me-2" />German</a>
                <a className="dropdown-item" href="#"><img src="assets/images/flags/french_flag.jpg" alt="" height="15" className="me-2" />French</a>
              </div>
            </li>

            <li className="topbar-item">
              <a className="nav-link nav-icon" href="javascript:void(0);" id="light-dark-mode">
                <i className="icofont-sun dark-mode"></i>
                <i className="icofont-moon light-mode"></i>
              </a>
            </li>

            <li className="dropdown topbar-item">
              <a className="nav-link dropdown-toggle arrow-none nav-icon" data-bs-toggle="dropdown" href="#" role="button" aria-haspopup="false" aria-expanded="false">
                <i className="icofont-bell-alt"></i>
                <span className="alert-badge"></span>
              </a>
              <div className="dropdown-menu stop dropdown-menu-end dropdown-lg py-0">
                <h5 className="dropdown-item-text m-0 py-3 d-flex justify-content-between align-items-center">
                  Notifications <a href="#" className="badge text-body-tertiary badge-pill"><i className="iconoir-plus-circle fs-4"></i></a>
                </h5>
                <ul className="nav nav-tabs nav-tabs-custom nav-success nav-justified mb-1" role="tablist">
                  <li className="nav-item" role="presentation">
                    <a className="nav-link mx-0 active" data-bs-toggle="tab" href="#All" role="tab" aria-selected="true">
                      All <span className="badge bg-primary-subtle text-primary badge-pill ms-1">24</span>
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a className="nav-link mx-0" data-bs-toggle="tab" href="#Projects" role="tab" aria-selected="false">
                      Projects
                    </a>
                  </li>
                  <li className="nav-item" role="presentation">
                    <a className="nav-link mx-0" data-bs-toggle="tab" href="#Teams" role="tab" aria-selected="false">
                      Team
                    </a>
                  </li>
                </ul>
                <div className="ms-0" style={{ maxHeight: '230px' }} data-simplebar>
                  <div className="tab-content" id="myTabContent">
                    <div className="tab-pane fade show active" id="All" role="tabpanel">
                      {/* Notification items */}
                      <NotificationItem time="2 min ago" icon="iconoir-wolf" title="Your order is placed" desc="Dummy text of the printing and industry." />
                      <NotificationItem time="10 min ago" icon="iconoir-apple-swift" title="Meeting with designers" desc="It is a long established fact that a reader." />
                      <NotificationItem time="40 min ago" icon="iconoir-birthday-cake" title="UX 3 Task complete." desc="Dummy text of the printing." />
                      <NotificationItem time="1 hr ago" icon="iconoir-drone" title="Your order is placed" desc="It is a long established fact that a reader." />
                      <NotificationItem time="2 hrs ago" icon="iconoir-user" title="Payment Successfull" desc="Dummy text of the printing." />
                    </div>
                    {/* Additional tab panes like Projects, Teams can be added similarly */}
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  );
};

const NotificationItem = ({ time, icon, title, desc }) => (
  <a href="#" className="dropdown-item py-3">
    <small className="float-end text-muted ps-2">{time}</small>
    <div className="d-flex align-items-center">
      <div className="flex-shrink-0 bg-primary-subtle text-primary thumb-md rounded-circle">
        <i className={`${icon} fs-4`}></i>
      </div>
      <div className="flex-grow-1 ms-2 text-truncate">
        <h6 className="my-0 fw-normal text-dark fs-13">{title}</h6>
        <small className="text-muted mb-0">{desc}</small>
      </div>
    </div>
  </a>
);

export default Topbar;